/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/VTreasury.json';
import { VTreasury } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetVTreasuryContractAddressInput {
  chainId: ChainId;
}

export const getVTreasuryContractAddress = ({ chainId }: GetVTreasuryContractAddressInput) =>
  getUniqueContractAddress({ name: 'VTreasury', chainId });

export const useGetVTreasuryContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getVTreasuryContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetVTreasuryContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getVTreasuryContract = ({ chainId, signerOrProvider }: GetVTreasuryContractInput) => {
  const address = getVTreasuryContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as VTreasury) : undefined;
};

interface UseGetVTreasuryContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetVTreasuryContract = (input?: UseGetVTreasuryContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getVTreasuryContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
